module.exports = __webpack_public_path__ + "static/img/3.f6f08ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-neo/3.png
// module id = Alw6
// module chunks = 12